import React from 'react';

interface UIExampleProps {
  title: string;
  description?: string;
  device?: 'phone' | 'desktop';
  children: React.ReactNode;
}

const UIExample: React.FC<UIExampleProps> = ({
  title,
  description,
  device = 'desktop',
  children
}) => {
  return (
    <div className="my-6">
      <div className="mb-3">
        <h4 className="font-medium text-gray-900">{title}</h4>
        {description && (
          <p className="text-sm text-gray-600 mt-1">{description}</p>
        )}
      </div>

      {device === 'phone' ? (
        // Phone frame
        <div className="flex justify-center">
          <div className="relative w-[280px] bg-gray-900 rounded-[2.5rem] p-2 shadow-xl">
            {/* Phone notch */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-6 bg-gray-900 rounded-b-xl z-10" />
            {/* Screen */}
            <div className="bg-white rounded-[2rem] overflow-hidden">
              <div className="h-[500px] overflow-y-auto">
                {children}
              </div>
            </div>
          </div>
        </div>
      ) : (
        // Desktop/browser frame
        <div className="border border-gray-200 rounded-lg shadow-lg overflow-hidden bg-white">
          {/* Browser chrome */}
          <div className="bg-gray-100 px-4 py-2 flex items-center gap-2 border-b border-gray-200">
            <div className="flex gap-1.5">
              <div className="w-3 h-3 rounded-full bg-red-400" />
              <div className="w-3 h-3 rounded-full bg-yellow-400" />
              <div className="w-3 h-3 rounded-full bg-green-400" />
            </div>
            <div className="flex-1 mx-4">
              <div className="bg-white rounded px-3 py-1 text-xs text-gray-500 max-w-md">
                reserveflow.app
              </div>
            </div>
          </div>
          {/* Content */}
          <div className="max-h-[400px] overflow-y-auto">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default UIExample;
